@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="m-3">
        <h1 mat-dialog-title>Edit Address</h1>
        <div mat-dialog-content [formGroup]="formControl">
            <div class="row mt-4">
                <div class="col-12 d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Address Line 1 <span class="red">*</span></mat-label>
                        <input matInput placeholder="Address Line 1" formControlName="addressLine1" [errorStateMatcher]="matcher" required>
                    </mat-form-field>
                    <mat-error *ngIf="!formControl.controls['addressLine1'].value">Address is Required</mat-error>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-12 d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Address Line 2</mat-label>
                        <input matInput placeholder="Address Line 2"
                            formControlName="addressLine2">
                    </mat-form-field>
                </div>
            </div>
            <div class="row justify-content-between mt-4">
                <div class="col-lg-6 col-12 d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>City <span class="red">*</span></mat-label>
                        <input matInput placeholder="City" formControlName="city"
                            [errorStateMatcher]="matcher" required>
                    </mat-form-field>
                    <mat-error *ngIf="!formControl.controls['city'].value"></mat-error>
                </div>
                <div class="col-lg-6 col-12 d-flex flex-column">
                    @if (usCountrySelectedBoolean) {
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>State<span class="required-input">*</span></mat-label>
                            <mat-select formControlName="state" required>
                                <mat-option *ngFor="let state of states" [value]="state.value">
                                    {{ state.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    } @else {
                        <mat-form-field appearance="outline">
                            <mat-label>State/Province</mat-label>
                            <input type="text" matInput placeholder="State/Province" formControlName="state">
                        </mat-form-field>
                    }
                </div>
            </div>
            <div class="row justify-content-between mt-4">
                <div class="col-lg-6 col-12 d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Zip/Postal Code <span class="red">*</span></mat-label>
                        <input matInput placeholder="Zip / Postal Code" formControlName="postalCode" [errorStateMatcher]="matcher" required>
                    </mat-form-field>
                    <mat-error *ngIf="!formControl.controls['postalCode'].value"></mat-error>
                </div>
                <div class="col-lg-6 col-12 d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Country <span class="red">*</span></mat-label>
                        <mat-select formControlName="country" [errorStateMatcher]="matcher" (selectionChange)="onCountrySelectionChange($event)" required>
                            <mat-option *ngFor="let country of countries" [value]="country.id">
                                {{ country.display_text }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="!formControl.controls['country'].value"></mat-error>
                </div>
            </div>
        </div>
        <div class="m-4 d-flex justify-content-end">
            <span class="red">*</span>&nbsp;- Required fields
        </div>
        <div class="my-2 d-flex justify-content-end">
            <button mat-raised-button class="cancel-button" (click)="onCloseClick()">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <button mat-raised-button class="action-button" (click)="onSaveClick()" [disabled]="!canSaveOrganizationAddress()">
                <mat-icon>check</mat-icon>
                Submit Organization
            </button>
        </div>
    </div>
}